/**
 * CR-6348: Supplier section of the reworked SO Lines filter panel.
 * Fields: Country, Group -> Site (Group -> Site cascade preserved).
 */
import type { LucideIcon } from 'lucide-react';
import SearchableSelect from '../../../../../ui/SearchableSelect';
import { POLinesFilters, FilterOptions } from '../../types';
import { FilterSection, FIELD_CLS, LABEL_CLS } from '../fieldStyles';

interface SupplierSectionProps {
  filters: POLinesFilters;
  onFilterChange: (key: string, value: string) => void;
  supplierCountries: string[];
  supplierGroups: NonNullable<FilterOptions['supplier_groups']>;
  supplierSiteOptions: FilterOptions['suppliers'];
  onSupplierGroupChange: (value: string) => void;
  onSupplierCountryChange: (value: string) => void;
  /** CR-6347: Optional icon for the section header */
  icon?: LucideIcon;
}

export function SupplierSection({
  filters,
  onFilterChange,
  supplierCountries,
  supplierGroups,
  supplierSiteOptions,
  onSupplierGroupChange,
  onSupplierCountryChange,
  icon,
}: SupplierSectionProps) {
  return (
    <FilterSection title="Supplier" icon={icon}>
      {/* Country — CR-6347: now cascades to clear supplier site */}
      <div>
        <label className={LABEL_CLS}>Country</label>
        <select
          value={filters.supplierCountry}
          onChange={(e) => onSupplierCountryChange(e.target.value)}
          className={FIELD_CLS}
        >
          <option value="">All Countries</option>
          {supplierCountries.map((c) => (
            <option key={c} value={c}>{c}</option>
          ))}
        </select>
      </div>

      {/* Group */}
      <div>
        <label className={LABEL_CLS}>Group</label>
        <SearchableSelect
          options={supplierGroups.map((g) => ({ value: String(g.id), label: g.name }))}
          value={filters.supplierGroup}
          onChange={onSupplierGroupChange}
          placeholder="All Supplier Groups"
        />
      </div>

      {/* Site (cascaded by Group) */}
      <div>
        <label className={LABEL_CLS}>Site</label>
        <SearchableSelect
          options={supplierSiteOptions.map((s) => ({ value: String(s.id), label: s.name }))}
          value={filters.supplier}
          onChange={(val) => onFilterChange('supplier', val)}
          placeholder="All Supplier Sites"
        />
      </div>

      {/* CR-7028: Supplier Code filter */}
      <div>
        <label className={LABEL_CLS}>Supplier Code</label>
        <input
          type="text"
          value={filters.supplierCode}
          onChange={(e) => onFilterChange('supplierCode', e.target.value)}
          placeholder="Enter supplier code"
          className={FIELD_CLS}
        />
      </div>
    </FilterSection>
  );
}
